<template>
  <div>
    <van-field
      :required="true"
      v-model="name"
      :readonly="true"
      label="下一步处理人"
      placeholder="请选择"
      input-align="right"
      right-icon="arrow-down"
      @click="clickXzry"
    />
    <van-popup v-model="show" position="bottom" :style="{ height: '80%' }">
      <van-search v-model="personName" show-action placeholder="请输入姓名" @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="u-content-wrap" style="padding-top: 12px;">
        <van-empty v-if="list.length == 0" description="暂无数据" />
        <div style="padding: 0px 12px; background: #ffffff; width: 100%">
          <div v-for="(item, index) in list" :key="index" @click="clickItem(item)" class="xzry-li">
            <div class="oa-contact-avatar">
              <span class="list_style" :class="getColor()">{{ splitName(item.realname) }}</span>
            </div>
            <div class="oa-contact-content">
              <div class="mui-clearfix">
                 {{ item.realname }}
              </div>
              <span class="oa-contact-email mui-h6">
                {{ item.orgCode_dictText }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
export default {
  props: {
    queryData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      list: [],
      workId: '',
      sjdj: '',
      sjlx: '',
      personName: '',
      orgCode: '',
      roleCode: '',
      cxfs: 'like',
      orgType: '',
      orgCategory: '',
      show: false,
      name:'',
      colorList: ['red', 'yellow', 'lightBlue', 'coffe', 'yellow', 'seaBlue', 'darkBlue', 'red', 'yellow', 'lightBlue'],
    }
  },
  created() {},
  watch: {
    queryData: {
      immediate: true,
      deep: true,
      handler() {
        this.orgCode = this.queryData.orgCode||'';
        this.roleCode = this.queryData.roleCode||'';
        this.cxfs = this.queryData.cxfs||'like';
        this.orgType = this.queryData.orgType||'';
        this.orgCategory = this.queryData.orgCategory||'';
      },
    },
  },
  computed: {
    disabled() {
      let validate = true
      if (this.address) {
        validate = false
      }
      return validate
    },
  },
  methods: {
    clickItem(item) {
      this.name = item.realname;
      this.show = false
      this.$emit('selectChange', item)
    },
    getColor: function () {
      var num = Math.floor(Math.random() * 10)
      return this.colorList[num]
    },
    splitName: function (name) {
      if (!name) {
        return name
      }
      return name.split('')[name.split('').length - 1]
    },
    clickXzry() {
      this.getData()
      this.show = true
    },
    getData() {
      var params = {
        orgCode: this.orgCode,
        roleCode: this.roleCode,
        cxfs: this.cxfs,
        orgType: this.orgType,
        orgCategory: this.orgCategory,
        realname: this.personName,
        pageSize: '1000',
      }
      console.log(params);
      getAction('/sys/user/role/codd/list', params).then((res) => {
        if (res.success) {
          let list = res.result.records
          this.list = list
        }
      })
    },
    onSearch() {
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 12px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.xzry-li {
  background: #ffffff;
  display: flex;
  flex-direction: row;
  padding: 10px 0px;
  align-items: center;
  border-bottom: 1px solid #dddddd;
}

.oa-contact-avatar {
  width: 60px;
}

.list_style {
  background: #f3f4f8;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 15px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}
.oa-contact-content {
  flex: 1;
}

/*颜色*/
.red {
  background: #d57171;
  color: #fff;
}
.coffe {
  background: #a47466;
  color: #fff;
}
.yellow {
  background: #f7b55e;
  color: #fff;
}
.darkBlue {
  background: #558aac;
  color: #fff;
}
.lightBlue {
  background: #4da9ec;
  color: #fff;
}
.lightCoffe {
  background: #bea487;
  color: #fff;
}
.seaBlue {
  background: #4198e7;
  color: #fff;
}

.btn {
  padding: 20px;
  display: flex;
  justify-content: space-around;
}

.b-btn {
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
</style>
